(() => {
  'use strict';
  const key = d => d.toISOString().slice(0,10);
  function easter(y) {
    const a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),n=h+l-7*m+114;
    return new Date(Date.UTC(y,Math.floor(n/31)-1,n%31+1,12));
  }
  function holidays(y) {
    const dates=['01-01','05-01','05-08','07-14','08-15','11-01','11-11','12-25'].map(md=>y+'-'+md),e=easter(y);
    [1,39,50].forEach(n=>{const d=new Date(e);d.setUTCDate(d.getUTCDate()+n);dates.push(key(d));});return new Set(dates);
  }
  function addBusinessDays(start,n) {
    const d=new Date(start);let year=d.getUTCFullYear(),off=holidays(year);
    while(n>0){d.setUTCDate(d.getUTCDate()+1);if(d.getUTCFullYear()!==year){year=d.getUTCFullYear();off=holidays(year);}if(d.getUTCDay()!==0&&d.getUTCDay()!==6&&!off.has(key(d)))n--;}return d;
  }
  function render() {
    const paris=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const part=t=>paris.find(p=>p.type===t).value;
    const today=new Date(Date.UTC(Number(part('year')),Number(part('month'))-1,Number(part('day')),12));
    const fmt=new Intl.DateTimeFormat('fr-FR',{timeZone:'UTC',weekday:'long',day:'numeric',month:'long'});
    const from=addBusinessDays(today,5),to=addBusinessDays(today,8);
    document.querySelectorAll('[data-av-delivery-window]').forEach(el=>{if(el.dataset.estimatedFrom===key(from)&&el.dataset.estimatedTo===key(to)&&el.querySelector('.avt-date-range'))return;
      const label=document.createElement('span');label.className='avt-date-label';label.textContent='Commandé aujourd’hui : livraison estimée';
      const range=document.createElement('strong');range.className='avt-date-range';
      const first=document.createElement('time');first.dateTime=key(from);first.textContent=fmt.format(from);
      const last=document.createElement('time');last.dateTime=key(to);last.textContent=fmt.format(to);
      range.append(document.createTextNode('entre le '),first,document.createTextNode(' et le '),last,document.createTextNode('.'));
      const order=document.createElement('span');order.className='avt-date-order';order.textContent='Pour une commande aujourd’hui';
      el.replaceChildren(label,document.createTextNode(' '),range,order);el.dataset.estimatedFrom=key(from);el.dataset.estimatedTo=key(to);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',render,{once:true});else render();
  document.addEventListener('shopify:section:load',render);window.addEventListener('pageshow',render);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)render();});setInterval(render,60000);
})();
